import React from 'react';
import { Phone, MapPin, Clock, MessageCircle } from 'lucide-react';

const ContactInfo = () => {
    return (
        <section id="contact" className="py-20 bg-coffee-900 text-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Section Header */}
                <div className="text-center mb-16">
                    <h2 className="text-4xl md:text-5xl font-display font-bold mb-4">
                        Get in Touch
                    </h2>
                    <p className="text-lg text-cream/80 max-w-2xl mx-auto">
                        Book your professional massage session today
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
                    {/* Phone */}
                    <div className="bg-white/10 glass p-6 rounded-2xl text-center hover:bg-white/20 transition-all duration-300">
                        <div className="bg-zen-gold w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                            <Phone size={28} />
                        </div>
                        <h3 className="font-bold text-xl mb-2">Call Us</h3>
                        <a
                            href="tel:+919901853969"
                            className="text-zen-gold hover:text-cream transition-colors text-lg font-semibold"
                        >
                            +91 9901853969
                        </a>
                    </div>

                    {/* WhatsApp */}
                    <div className="bg-white/10 glass p-6 rounded-2xl text-center hover:bg-white/20 transition-all duration-300">
                        <div className="bg-green-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                            <MessageCircle size={28} />
                        </div>
                        <h3 className="font-bold text-xl mb-2">WhatsApp</h3>
                        <a
                            href="https://wa.me/919901853969"
                            className="text-zen-gold hover:text-cream transition-colors text-lg font-semibold"
                        >
                            Chat Now
                        </a>
                    </div>

                    {/* Location */}
                    <div className="bg-white/10 glass p-6 rounded-2xl text-center hover:bg-white/20 transition-all duration-300">
                        <div className="bg-zen-gold w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                            <MapPin size={28} />
                        </div>
                        <h3 className="font-bold text-xl mb-2">Location</h3>
                        <p className="text-cream/80">
                            J.P. Nagar
                            <br />
                            Bengaluru, 560078
                        </p>
                    </div>

                    {/* Hours */}
                    <div className="bg-white/10 glass p-6 rounded-2xl text-center hover:bg-white/20 transition-all duration-300">
                        <div className="bg-zen-gold w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                            <Clock size={28} />
                        </div>
                        <h3 className="font-bold text-xl mb-2">Service Hours</h3>
                        <p className="text-cream/80">
                            Mon - Sun
                            <br />
                            7:00 AM - 10:00 PM
                        </p>
                    </div>
                </div>

                {/* CTA Section */}
                <div className="bg-gradient-to-r from-zen-gold/20 to-zen-gold/10 glass p-8 md:p-12 rounded-2xl text-center">
                    <h3 className="text-3xl font-display font-bold mb-4">
                        Ready to Experience Professional Massage?
                    </h3>
                    <p className="text-cream/80 mb-8 text-lg max-w-2xl mx-auto">
                        Book your session with a certified, government-registered therapist.
                        Direct service, professional care, guaranteed satisfaction.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <a
                            href="tel:+919901853969"
                            className="bg-zen-gold text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white hover:text-coffee-900 transition-all duration-300 shadow-premium inline-flex items-center justify-center space-x-2"
                        >
                            <Phone size={20} />
                            <span>Call: +91 9901853969</span>
                        </a>
                        <a
                            href="https://wa.me/919901853969"
                            className="bg-green-500 text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-green-600 transition-all duration-300 shadow-premium inline-flex items-center justify-center space-x-2"
                        >
                            <MessageCircle size={20} />
                            <span>WhatsApp Us</span>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactInfo;
